import { render, staticRenderFns } from "./ImportResult.vue?vue&type=template&id=012b8f67&"
import script from "./ImportResult.vue?vue&type=script&lang=js&"
export * from "./ImportResult.vue?vue&type=script&lang=js&"
import style0 from "./ImportResult.vue?vue&type=style&index=0&id=012b8f67&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable})
